import Seo from "../components/Seo";
import HomeHero from "../sections/HomeHero";
import ClientsMarquee from "../sections/ClientsMarquee";
import StatementSection from "../sections/StatementSection";
import MemorySection from "../sections/MemorySection";
import ServicesSection from "../sections/ServicesSection";
import WhyAiSection from "../sections/WhyAiSection";
import ManifestoSection from "../sections/ManifestoSection";
import PillarsSection from "../sections/PillarsSection";
import ServeSection from "../sections/ServeSection";
import ToolsSection from "../sections/ToolsSection";
import HowItWorksSection from "../sections/HowItWorksSection";
import StatsProofSection from "../sections/StatsProofSection";
import CalculatorSection from "../sections/CalculatorSection";
import TestimonialsSection from "../sections/TestimonialsSection";
import ModelsSection from "../sections/ModelsSection";
import InsightsSection from "../sections/InsightsSection";
import FaqSection from "../sections/FaqSection";
import FinalCta from "../sections/FinalCta";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo
        title="Quexify — Your AI-Augmented Real Estate Right Hand"
        description="Quexify is the AI-augmented right hand for real estate agents and teams. We run transactions, marketing, leads, calendar and admin so you close more and chase less."
        path="/"
      />
      <HomeHero />
      <ClientsMarquee />
      <StatementSection />
      <MemorySection />
      <ServicesSection />
      <ToolsSection />
      <WhyAiSection />
      <ManifestoSection />
      <PillarsSection />
      <ServeSection />
      <HowItWorksSection />
      <StatsProofSection />
      <CalculatorSection />
      <TestimonialsSection />
      <ModelsSection />
      <InsightsSection />
      <FaqSection />
      <FinalCta />
    </div>
  );
}
